import React, { useEffect, useState } from "react";
import Markdown from "react-markdown";
import { useParams } from "react-router-dom";
import readmeCodePush from "../assets/README/README.code_push.md";

const readmeType = {
    code_push: readmeCodePush,
};

const Blog = () => {
    const [markdown, setMarkdown] = useState(null);
    const { name } = useParams();

    useEffect(() => {
        if (!readmeType[name]) {
            setMarkdown("Content not found.");
            return;
        }

        fetch(readmeType[name])
            .then((response) => response.text())
            .then((text) => {
                window.scrollTo(0, 0);
                setMarkdown(text);
            });
    }, [name]);

    return (
        <main className=" min-h-screen p-4 bg-[#191919]">
            <Markdown className="min-h-screen m-auto max-w-[768px] prose prose-headings:text-[#ffffffcf] prose-p:text-[#ffffffcf] prose-ul:text-[#ffffffcf] prose-code:text-[#ffffffcf]  prose-a:text-[#4493f8]">
                {markdown + ``}
            </Markdown>
        </main>
    );
};

export default Blog;
